import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { FlatButton } from '@ui/buttons/Button.tsx';

const ControlsWrapper = styled('div')`
  display: ${({ $isOpen }) => ($isOpen ? 'none' : 'flex')};
  padding: 12px;
`;
const StyledFlatButton = styled(FlatButton)`
  flex: 1 0 auto;
  border-radius: 8px;
`;

const EditButton = styled(StyledFlatButton)`
  color: var(--color-secondaryButtonText);
  background-color: var(--color-secondaryButton);

  &:not([disabled]):hover {
    color: var(--color-secondaryButtonText);
    background-color: var(--color-secondaryButtonHover);
  }
`;
const EndButton = styled(StyledFlatButton)`
  color: var(--color-destructiveButtonText);
  background-color: var(--color-destructiveButton);

  &:not([disabled]):hover {
    color: var(--color-destructiveButtonText);
    background-color: var(--color-destructiveButtonHover);
  }
`;
const Spacer = styled('div')`
  width: 13px;
`;

const EnrouteControls = ({ ...props }) => {
  const {
    isOpen,
    editRouteLabel = 'Edit Route',
    endRouteLabel = 'End Route',
    onEditRouteClick,
    onEndRouteClick,
  } = props;

  return (
    <ControlsWrapper data-testid="EnRouteControls" $isOpen={isOpen}>
      <EditButton data-testid="EditButton" onClick={onEditRouteClick}>
        {editRouteLabel}
      </EditButton>
      <Spacer />
      <EndButton data-testid="EndButton" onClick={onEndRouteClick}>
        {endRouteLabel}
      </EndButton>
    </ControlsWrapper>
  );
};

EnrouteControls.propTypes = {
  /** A string to be passed into the 'edit route' button. */
  editRouteLabel: PropTypes.string,
  /** A string to be passed into the 'end route' button. */
  endRouteLabel: PropTypes.string,
  /** A callback for the edit route button on click. */
  onEditRouteClick: PropTypes.func.isRequired,
  /** A callback for the end route button on click. */
  onEndRouteClick: PropTypes.func.isRequired,
};

export { EnrouteControls };
